import { CONFIG } from "~/config";
import ReportHubDialog from "~/report/reportHubDialog";
import { onAddPlace, onMapError, onMapNote, onSomethingWrong } from "~/util/feedback";

export function exclusiveBoxesSetState(state: any) {
	if (CONFIG.inFrame) {
		return;
	}

	if ("feedback" in state) {
		switch (state.feedback) {
			case "addplace":
				onAddPlace(true);
				break;

			case "error":
				onSomethingWrong(true);
				break;

			case "maperror":
				onMapError(true);
				break;

			case "note":
				onMapNote(true);
				break;

			case "menu": {
				const reportHubDialog = new ReportHubDialog();

				reportHubDialog.open();
				break;
			}

			default:
				//
		}
	}

	if ("box" in state) {
		switch (parseInt(state.box)) {
			case 1:
				break;

			case 2:
				Mapy.getComponent("reportDefect").activate();
				break;

			default:
		}
	} else {
		const rd = Mapy.getComponent("reportDefect");

		if (rd && rd.isActive()) {
			rd.deactivate();
		}
	}
}
